import { graphql } from "../gql";

export const sendUserOnboardNotificationMutationDoc = graphql(`
  mutation sendUserOnboardNotification(
    $input: SendUserOnboardNotificationInput!
  ) {
    sendUserOnboardNotification(input: $input) {
      messageCreatedId
      notificationKind
      notifications {
        email {
          rejected
          response
          success
        }
        messageSentId
        recipientUserEmail
        recipientUserId
      }
    }
  }
`);
